/* Zareen Jewels — About page: reveal on scroll + count-up for the piece number */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (root) => {
    if (!root || root.dataset.zjaReady || reduce || !('IntersectionObserver' in window)) return;
    root.dataset.zjaReady = '1';
    root.classList.add('is-ready');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
        const n = e.target.querySelector('[data-zja-count]');
        if (n) {
          const end = Number(n.dataset.zjaCount) || 0;
          const t0 = performance.now();
          const step = (t) => {
            const p = Math.min(1, (t - t0) / 1400);
            n.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('.zja-reveal').forEach((el) => io.observe(el));
  };
  const boot = (scope) => scope.querySelectorAll('[data-zja]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
